module.exports = __webpack_public_path__ + "images/hellorider_small6a2d076c41f28a15d09d3a896cdb9185.png";